
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#4ac692","width":"16","height":"16.001"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"inherit"}},[_c('path',{attrs:{"d":"M7 4h1v4.328H7z"}}),_c('path',{attrs:{"d":"M7 8h4.946v1H7zM15.5 8C15.5 3.866 12.135.5 8 .5 3.864.5.5 3.865.5 8 .5 3.866 3.864.5 8 .5c4.135 0 7.5 3.365 7.5 7.5z"}}),_c('path',{attrs:{"d":"M8 16c-4.412 0-8-3.588-8-8C0 3.59 3.588 0 8 0c4.41 0 8 3.589 8 8 0 4.412-3.59 8-8 8zM8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7z"}})])])
          )
        }
      }
    